export function translateErrorMessage(translate, message) {
  const messageParts = message.split(":");

  if (
    translate("website.goodbits." + messageParts[0]) !==
    "website.goodbits." + messageParts[0]
  ) {
    return translate("website.goodbits." + messageParts[0]);
  }

  return message;
}
